import { useMutation } from 'react-query';
import addRoomOwners from '../requests/addRoomOwners';

const useAddRoomOwnersMutation = (options) =>
  useMutation(({ owners, room }) => addRoomOwners(owners, room), options);

export default useAddRoomOwnersMutation;
